import { api } from './api';

export interface CampoInscricao {
  campo: string;
  id_tipo_campo: string;
  obrigatorio: boolean;
  ordem: number;
}

export interface CampoTipo {
  id: string;
  nome: string;
  tipo_input: string;
}

export interface CategoriaCampo {
  id: string;
  campo: string;
  obrigatorio: boolean;
  ordem: number;
  tipoCampo: CampoTipo;
}

export interface CategoriaInscricao {
  id: string;
  id_grupo: string;
  titulo: string;
  data_inicio: string;
  data_fim: string;
  ativo: boolean;
  criado_em: string;
  militarCriou?: { id: string; nick: string };
  campos: CategoriaCampo[];
}

export interface InscricaoCampo {
  id: string;
  valor: string;
  campoDef: CategoriaCampo;
}

export interface Inscricao {
  id: string;
  nick_inscricao: string;
  patente_inscricao: string;
  termo_aceito: boolean;
  criado_em: string;
  militar?: { id: string; nick: string };
  campos: InscricaoCampo[];
}

export interface CriarCategoriaDTO {
  titulo: string;
  data_inicio: string;
  data_fim: string;
  campos: CampoInscricao[];
}

export interface RealizarInscricaoDTO {
  termo_aceito: boolean;
  valores_campos: Array<{ id_campo: string; valor: string }>;
}

const inscricoesService = {
  async criarCategoria(id_grupo: string, data: CriarCategoriaDTO): Promise<CategoriaInscricao> {
    const response = await api.post(`/grupos/${id_grupo}/inscricoes/categorias`, data);
    return response.data;
  },

  async listarCategorias(id_grupo: string): Promise<CategoriaInscricao[]> {
    const response = await api.get(`/grupos/${id_grupo}/inscricoes/categorias`);
    return response.data;
  },

  async alterarStatus(id_categoria: string, ativo: boolean): Promise<CategoriaInscricao> {
    const response = await api.patch(`/grupos/inscricoes/categorias/${id_categoria}/status`, { ativo });
    return response.data;
  },

  async listarInscricoes(id_categoria: string): Promise<Inscricao[]> {
    const response = await api.get(`/grupos/inscricoes/categorias/${id_categoria}/inscricoes`);
    return response.data;
  },

  async realizarInscricao(id_categoria: string, data: RealizarInscricaoDTO): Promise<Inscricao> {
    const response = await api.post(`/grupos/inscricoes/categorias/${id_categoria}/inscrever`, data);
    return response.data;
  },
};

export { inscricoesService };
